import TRANSLATIONS from './json/it_CH_translations.json'

const TRANSLATIONS_IT_CH = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Passa sopra con il mouse per ingrandire',
  'shopping_cart_details.tapToZoom': 'Tocca per ingrandire',
  'coupon_code.page_link': 'national-pen-codici-sconto',
  'address.company': `Nome dell'azienda`,//fallback as apostrophe creates issue in createTranslation script
  'order_summary.your_promos' :' Le tue promozioni',
  'shopping_cart_details.editImprint': 'Modifica stampa',
  'shopping_cart_details.clickToZoom': 'Fai clic per ingrandire',
  'shopping_cart_details.ships_within_msg': 'Spedizione in [X] giorni lavorativi',
  'shopping_cart_details.item_total': 'Totale articoli:',
  'shopping_cart_details.each': '[X] per unità',
  'shopping_cart_details.see_more': 'Mostra Di Più',
  'shopping_cart_details.see_less': 'Mostra Meno',
  'order_confirmation.cartToOrderFailureMessage' : 'Il tuo ordine verrà confermato a breve.',
  'checkout_payment.paymentErrorTitle': 'Errore di pagamento',
  'checkout_payment.paymentErrorMessage': 'Prova a reinserire i dettagli di pagamento. Se il problema persiste, contatta il team di assistenza clienti per chiedere aiuto.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Credito/debito',
  'checkout_payment.card_number': 'Numero della carta*',
  'checkout_payment.expiration_mm_yy': 'MM/AA*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Nome sulla carta*',
  'checkout_payment.check_cc_try_again': 'Verifica il numero della carta di credito e ritenta.',
  'checkout_payment.check_date_try_again': 'Verifica la data e ritenta.',
  'checkout_payment.check_code_try_again': 'Verifica il codice e ritenta.',
  'checkout_payment.enter_holder_name': 'Inserisci il nome riportato sulla carta.',
  'checkout_payment.enter_cc_number': 'Inserisci il numero della carta di credito.',
  'checkout_payment.enter_expiration_date': 'Inserisci la data di scadenza.',
  'checkout_payment.enter_cvv': 'Inserisci il codice di sicurezza.',
  'checkout_payment.paypal_pay_later': 'PayPal Pay Later',
  'checkout_payment.continue_will_open_paypal_account_msg': 'Se continui, ti indirizzeremo alla pagina del tuo account PayPal.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'Continua per Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Paga tramite fattura',
  'checkout_payment.buy_now_pay_later_info_msg': 'Acquista ora e paga dopo! Ti invieremo una fattura non appena il tuo ordine verrà spedito.',
  'checkout_payment.learn_more': 'Scopri di più',
  'checkout_payment.payment_due_late_fee_info_msg': 'Il pagamento dovrà essere saldato al ricevimento della fattura. I ritardi nel pagamento sono soggetti a costi aggiuntivi.',
  'shopping_cart_details.unit': 'pezzo',
  'shopping_cart_details.editModalSaving': `Stai risparmiando`,
  'shopping_cart_details.editModalMin_QtyWarning': `Purtroppo la cifra inserita è inferiore alla nostra quantità minima. Contattaci per fare un ordine più piccolo.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Purtroppo la cifra inserita è superiore alla nostra quantità massima. Contattaci per fare un ordine più grande.`,
  'product_details.price':'Prezzo',
  'product_details.edit_quantity':'Modifica la quantità',
  'myaccount_order_details.seeDetails': 'Vedi dettagli',
  'myaccount_order_details.viewOrderDetails': 'Visualizza i dettagli dell’ordine',
  'myaccount_order_details.payMyInvoice': 'Pagamento fattura',
  'myaccount_order_details.buyItAgain': 'Ripeti l’acquisto',
  'myaccount_order_details.viewImprint': 'Visualizza stampa',
  'myaccount_order_details.viewArtwork': 'Visualizza la tua grafica',
  'myaccount_order_details.productDetails': 'Dettagli prodotto',
  'myaccount_order_details.orders': 'ordini',
  'my_account_order_details.shipping_and_billing_addresses': 'Indirizzi di spedizione e di fatturazione',
  'my_account_order_details.log_in_to_view' : 'Effettua l’accesso per vedere',
  'error.use_of_old_password': 'La password deve essere diversa dalle ultime 5.',
  'order_confirmation.postCheckout_signIn':`Accedi per ottenere maggiori vantaggi`,
  'order_confirmation.postCheckout_accountCreation':'Registrati per ottenere maggiori vantaggi',
  'order_confirmation.postCheckout_trackOrder':'Segui comodamente il tuo ordine',
  'order_confirmation.would_you_like_to':'Ottieni sconti speciali e campioni gratuiti ricevendo le offerte via email e telefono di Pens.com!',
  'order_confirmation.sign_up.contact_agreement1':'Sì',
  'order_confirmation.sign_up.contact_agreement2':', adoro le offerte!',
  'order_confirmation.sign_up.contact_disagreement1':'No',
  'order_confirmation.sign_up.contact_disagreement2':', grazie',
  'create_account.title':'Crea il tuo account',
  'order_confirmation.sign_in.title':'Accedi al tuo account',
  'order_confirmation.my_acc.title':'Il mio account',
  'order_confirmation.addPassword':'Aggiungi una password:',
  'order_confirmation.accountCreated':'Account creato',
  'myaccount_address_list.shippingAddresses': 'Indirizzi di spedizione',
  'myaccount_address_list.billingAddresses': 'Indirizzi di fatturazione',
  'myaccount_address_list.defaultAddress': 'Indirizzo predefinito',
  'myaccount_address_list.setDefault': 'Imposta predefinito',
  'myaccount_delete_address.delete_confirmation': 'Elimina la conferma',
  'myaccount_delete_address.confirmation_message': 'Davvero vuoi eliminare questo indirizzo?',
  'myaccount_delete_address.delete_address': 'Elimina l’indirizzo',
  'myaccount_delete_address.delete': 'Elimina',
  'myaccount_error_new_password.complexity':"La nuova password deve comprendere un numero, un carattere speciale [!#$%&'*+-/=?^_`{|}~.@], maiuscole e minuscole.",
  'myaccount_error_confirm_password.complexity':"La password confermata deve comprendere un numero, un carattere speciale [!#$%&'*+-/=?^_`{|}~.@], maiuscole e minuscole.",
  'myaccount_error_new_password.common_password':'La nuova password non può corrispondere al tuo indirizzo email.',
  'myaccount_error_confirm_password.common_password':'La password confermata non può corrispondere al tuo indirizzo email.',
  'myaccount.change_personal_information.change_password_info' : 'Tutti i dispositivi attivi verranno disconnessi.',
  'validation.password_validation_heading' : 'Le password devono comprendere:',
  'validation.password_validation_uppercase' : 'una maiuscola',
  'validation.password_validation_lowercase' : 'una minuscola',
  'validation.password_validation_symbol' : 'un carattere speciale',
  'validation.password_validation_number' : 'un numero',
  'validation.password_validation_length' : 'Almeno 8 caratteri',
  'validation.password_validation_match' : 'Le password devono corrispondere',
  'validation.password_min_characters': 'La password deve contenere almeno 8 caratteri.',
  'myaccount_password_settings.heading' : 'Impostazioni password',
  'myaccount_password_settings.newPassword' : 'Nuova password',
  'myaccount_password_settings.confirmPassword' : 'Conferma password',
  'myaccount_password_settings.updatePassword' : 'Aggiorna password',
  'myaccount_password_settings.createPassword' : 'Crea password',
  'myaccount_password_settings.use_of_old_password': 'La password deve essere diversa dalle ultime cinque.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'dashboard.edit' : 'Modifica',
  'dashboard.greeting':'Salve!',
  'myaccount_personal_info.save_changes' : 'Salva modifiche',
  'myaccount_personal_info.cancel' : 'Annulla',
  'myaccount_personal_info.name_title' : 'Nome',
  'myaccount_personal_info.password_title' : 'Password',
  'myaccount_personal_info.add_name' : 'Inserisci nome',
  'myaccount_personal_info.edit_name' : 'Modifica nome',
  'myaccount_personal_info.name_updated' : 'Nome aggiornato.',
  'myaccount.something_went_wrong': 'Qualcosa è andato storto. Ritenta.',
  'checkout.reorder.buy_it_again':'Ripeti l’acquisto',
  'checkout.reorder.purchased':'Acquistato',
  'checkout.reorder.last_qty':'Ultima quantità ordinata',
  'checkout.reorder.ships_within_msg':'Spedizione in [X] giorni lavorativi',
  'checkout.reorder.add_to_cart': 'Aggiungi al carrello',
  'checkout_payment.klarna_text' : 'Klarna',
  'checkout_payment.klarna_continue_text': 'Se continui, ti indirizzeremo alla pagina del tuo account Klarna.',
  'shopping_cart_details.add_accessory': 'Aggiungi un accessorio',
  'shopping_bag.expired_discount_coupon':'Il codice promozionale inserito è scaduto. Inseriscine uno valido.',
  'shopping_bag.invalid_discount_coupon':'Il codice promozionale inserito non è valido. Inseriscine uno valido.',
  'order_summary.oops_error': 'Ooops! Sembra che qualcosa sia andato storto! Ritenta.',
  'order_summary.one_promo_at_a_time': 'Può essere applicato solo un codice promozionale alla volta.',
  'order_summary.code_applied': 'Codice applicato',
  'order_summary.change_promo': 'Cambia il codice promozionale',
  'order_summary.your_promo_code': 'I tuoi codici promozionali',
  'order_summary.no_items_eligible': 'Nessuno degli articoli nel carrello è idoneo all’applicazione di questo codice promozionale.',
  'shopping_cart_details.add_amount': 'Ti mancano [X] per sbloccare l’offerta',
  'order_details.production_time_begin_msg': '*Il tempo necessario alla produzione inizia quando l’ordine è confermato e il design approvato.',
  'order_details.reorder_tat': 'Gli ordini ripetuti vengono spediti in X giorni lavorativi*',
  'import_charge_title':'Costo di importazione',
  'import_charge_description': 'I recenti costi di importazione hanno avuto ripercussioni sui prezzi dei nostri prodotti. Stiamo lavorando per mitigare l’impatto degli aumenti dei prezzi sui nostri clienti.',
  'gdpr.heading' : 'Account creato, ti diamo il benvenuto!',
  'gdpr.subheading' : 'Il tuo account è stato creato utilizzando il tuo indirizzo e-mail:',
  'gdpr.promotion': 'Iscriviti alla newsletter di Pens.com per ricevere offerte speciali e campioni gratuiti.',
  'gdpr.yesDeal' : 'Sì, desidero ricevere le offerte.',
  'gdpr.noDeal' : 'No, grazie.',
  'gdpr.button' : 'Continua',
  'new_activation.head' : 'Controlla l’e-mail!',
  'new_activation.sub_head' : 'Salve',
  'new_activation.main_body1' : 'Grazie per l’iscrizione a Pens.com',
  'new_activation.main_body2' : 'Un link di attivazione verrà inviato all’indirizzo email registrato',
  'new_activation.main_body3' : 'Non sarà possibile accedere al Profilo Cliente se la procedura di attivazione non sarà eseguita. Basterà cliccare sul link di attivazione per attivare il Profilo Cliente.',
  'myaccount_personal_info.password_not_set' : 'Non è stata impostata la password per questo account. Fai',
  'myaccount_personal_info.click_here' : 'clic qui ',
  'myaccount_personal_info.to_reset_password' : 'per creare una nuova password. ',
  'myaccount_personal_info.note' : 'Nota: questa azione comporta la disconnessione da tutte le sessioni attive.',
  'oos.item_out_of_stock': 'Questo articolo è momentaneamente esaurito.',
  'oos.view_similar': 'Vedi prodotti simili',
  'oos.similar_products': 'Prodotti simili',
  'oos.remove_out_of_stock_items': 'Per favore, rimuovi gli articoli esauriti dal carrello.',
  'oos.one_or_more_items_removed_from_cart': 'Una o più taglie sono esaurite e sono state eliminate da questo articolo.',
  'oos.go_back_to_review': 'Torna al carrello e rivedi',
  'oos.go_back_to_remove': 'Torna al carrello e rimuovi l’articolo',
  'oos.out_of_stock': 'Articolo esaurito',
  'moq.lineItem_warning': 'La quantità dell’ordine è inferiore al numero minimo di unità per questo articolo.',
  'moq.edit_qantity_link_text': 'Seleziona una quantità diversa.',
  'moq.cart_level_warning': 'Aggiorna la quantità dell’ordine per procedere con il pagamento.',
  'moq.go_back_to_cart': 'Torna al carrello per selezionare una nuova quantità dell’ordine',
  ...TRANSLATIONS
};
export default TRANSLATIONS_IT_CH;